export type WicketAdminCampaignStats = Record<StatisticName, StatisticDataPoint[]>;

export type WicketAdminCampaignAggregatedStats = Record<StatisticName, number>;

export type StatisticName =
  | 'Delivery'
  | 'Send'
  | 'Open'
  | 'Click'
  | 'Bounce'
  | 'Complaint';

export interface StatisticDataPoint {
  Timestamp: string;
  Sum: string;
}
